<template>
    <section class="balance-view">
        <HeaderComponent :title="'Saldo'" />

        <div class="balance-container">
            <div class="list-fields">
                <div v-for="(field, key) in fields" :key="key" class="list-field">
                    <h1 v-text="field"></h1>
                    <i class="fa fa-arrow-down icon" @click="orderBalance(field)"></i>
                </div>
            </div>
            <div class="loading" v-if="loading">
                <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
            </div>
            <div class="list" v-else-if="Object.values(balanceList).length > 0" >
                <div class="son-data" v-for="(son, key) in balanceList" :key="key">
                    <span>
                        {{ son.NMCONSUMIDOR }}
                    </span>
                    <div class="list-item" v-for="(item, ikey) in son.balance" :key="ikey">
                        <div class="list-item-field">
                            <h1 class="schoolName" v-text="item.NMFAMILISALD"></h1>
                        </div>
                        <div class="list-item-field">
                            <h1 v-text="formatValue(item.VRSALDCONFAM)"></h1>
                        </div>
                    </div>
                </div>
            </div>
            <div class="not-found" v-else>
                <h1>Não foram encontrados resultados</h1>
            </div>

        </div>
    </section>
</template>

<script>
import { getFullBalance } from '@/components/controllers/FinancialSummaryController'
import HeaderComponent from '@/components/header/HeaderComponent.vue'

export default {
    name: 'BalanceView',
    components: {
        HeaderComponent
    },
    data () {
        return {
            fields: ['Loja', 'Valor'],
            balanceList: [],
            isSorted: false,
            loading: false
        }
    },
    mounted () {
        this.loading = true
        getFullBalance().then(response => {
            if (response?.length > 0) {
                // group´s by CDCONSUMIDOR
                const groupedByConsumer = response.reduce((acc, item) => {
                    const { CDCONSUMIDOR, NMCONSUMIDOR } = item
                    const consumer = acc[CDCONSUMIDOR] || { CDCONSUMIDOR, NMCONSUMIDOR, balance: [] }
                    consumer.balance.push(item)
                    acc[CDCONSUMIDOR] = consumer
                    return acc
                }, {})
                this.balanceList = groupedByConsumer
            }
            this.loading = false
        })
    },
    methods: {
        formatValue (value) {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },
        orderBalance: function (field) {
            this.isSorted = !this.isSorted
            const sortingField = field === 'Loja' ? 'NMFAMILISALD' : 'VRSALDCONFAM'

            // need to sort the "balance" array inside the object "balanceList
            this.balanceList = Object.values(this.balanceList).map(item => {
                item.balance.sort((a, b) => {
                    if (this.isSorted) {
                        return a[sortingField] < b[sortingField] ? -1 : a[sortingField] > b[sortingField] ? 1 : 0
                    } else {
                        return a[sortingField] > b[sortingField] ? -1 : a[sortingField] < b[sortingField] ? 1 : 0
                    }
                })
                return item
            })
        }
    }

}
</script>

<style lang="less" scoped>
.balance-container {
    .list-fields {
        display: flex;
        justify-content: space-between;
        padding: 0 4px;
        h1 {
            margin-bottom: 10px;
            font-weight: 600;
        }
        .list-field {
            display: flex;
            flex-direction: row;
            align-items: baseline;

            h1 {
                margin-right: 4px;
            }
        }
    }

    .list {
        height: calc(100vh - 107px);
        overflow-y: auto;

        &::-webkit-scrollbar {
            display: none;
        }

        .son-data {
            margin: 20px auto 40px auto;

            span {
                padding: 0 4px;
                font-weight: 600;
                color: var(--iconColor)
            }
        }

        .list-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 20px;
            padding-bottom: 20px;
            padding: 20px 10px;
            border: 1px solid var(--cardBorder);
            box-shadow: 2px 2px 4px var(--cardBorder);
            border-radius: 5px;

            .list-item-field:first-child {
              padding-right: 15px
            }

            .schoolName {
                max-width: 100%;
            }

            &:last-of-type {
                margin-bottom: 20px;
            }
        }
    }

    .not-found, .loading {
        display: flex;
        justify-content: center;
        h1 {
            font-weight: 600;
        }
    }
}

</style>
